import {computed, watch} from 'vue';
import {useDataTracking, useRoute} from '#imports';
import {useLandingTrackingSource} from '~/common/composables';

export type ProjectViewTab = 'tasks' | 'invoices' | 'details';

// The "activity" route is labelled "Tasks" in the UI
const ROUTE_NAME_TO_TAB: Record<string, ProjectViewTab> = {
    'project-projectId-index-activity': 'tasks',
    'project-projectId-index-invoices': 'invoices',
    'project-projectId-index-details': 'details',
};

export function projectViewTabFromRouteName(routeName: unknown): ProjectViewTab | undefined {
    if (typeof routeName !== 'string') {
        return undefined;
    }
    return ROUTE_NAME_TO_TAB[routeName];
}

export function useProjectViewTabTracking() {
    const route = useRoute();
    const {track} = useDataTracking();
    const {getLandingTrackingSource} = useLandingTrackingSource();

    const tab = computed(() => projectViewTabFromRouteName(route.name));

    let isFirstView = true;

    function trackProjectViewViewed() {
        const projectId = route.params.projectId;
        if (!tab.value || typeof projectId !== 'string') {
            return;
        }
        track('client_project_view_viewed', {
            project_id: projectId,
            tab: tab.value,
            source: isFirstView ? getLandingTrackingSource() : 'project_view',
        });
        isFirstView = false;
    }

    // Tab switches within the project view
    watch(tab, trackProjectViewViewed);

    return {trackProjectViewViewed};
}
